import { markReviewerRoles } from 'pages/marking/helpers/request-params.helpers';
import { type BaseCustomerUser } from 'services/assist-api/entities/customer-user/types';

export function getOrganisationUserFromActiveReviewerId(
  activeReviewerId: number | undefined,
  organisationUsers: BaseCustomerUser[]
): BaseCustomerUser | undefined {
  return organisationUsers.find((ou) => ou.id === activeReviewerId);
}

/**
 * Further escalation roles are currently the same as mark reviewer roles, but may be changed in
 * the future. Our form is set up to allow the further escalation roles to be a subset of mark
 * reviewer roles by modifying this list. The Site Admin role cannot be added to an organisation and
 * [School] Admins can no longer access the Marking section as of frontend#799.
 */
export const furtherEscalationRoles = markReviewerRoles;

export function orgUsersWhoCanReviewEscalatedMarks(
  organisationUsers: BaseCustomerUser[]
): BaseCustomerUser[] {
  return organisationUsers.filter((orgUser) =>
    orgUser.roles?.some((role) => furtherEscalationRoles.includes(role.name))
  );
}
